import type { AnnotationT, BulkAnnotationT } from '../../types';
import { type ImportAnnotationsPayloadT } from '../actionReducers/annotations/annotations';
import { ACTION } from './constants';
export function addAnnotationAction(frameIndex: number, annotationIdx: string, annotationData: AnnotationT) {
  return {
    type: ACTION.ADD_ANNOTATION,
    frameIndex,
    annotationIdx,
    annotationData
  };
}
export function bulkAddAnnotationsAction(annotations: BulkAnnotationT[]) {
  return {
    type: ACTION.BULK_ADD_ANNOTATIONS,
    annotations
  };
}
export function deleteAnnotationAction(frameIndex: number, annotationIdx: string) {
  return {
    type: ACTION.DELETE_ANNOTATION,
    frameIndex,
    annotationIdx
  };
}
export function deleteAnnotationsAction(payload?: {
  currentFrame?: number;
  annotationLabels?: string[];
}) {
  return {
    ...payload,
    type: ACTION.DELETE_ANNOTATIONS
  };
}
export function updateAnnotationAction(frameIndex: number, annotationIdx: string, annotationData: AnnotationT) {
  return {
    type: ACTION.UPDATE_ANNOTATION,
    frameIndex,
    annotationIdx,
    annotationData
  };
}
export function importMLAnnotationsAction(payload: ImportAnnotationsPayloadT) {
  return {
    type: ACTION.IMPORT_ANNOTATIONS,
    ...payload
  };
}